/**
 * description:
 * Homepage "Meet the Board" teaser with circular headshots for the
 * 2026-2027 executive board, linking out to the full board page.
 */
import { Box, Typography } from "@mui/material";
import EyebrowLabel from "../../../utils/EyebrowLabel";

import President from "../../../pictures/ExecutiveBoard67/President.jpg";
import EVP from "../../../pictures/ExecutiveBoard67/EVP.jpg";
import IVP from "../../../pictures/ExecutiveBoard67/IVP.jpg";
import Secretary from "../../../pictures/ExecutiveBoard67/Secretary.jpg";
import Treasurer from "../../../pictures/ExecutiveBoard67/Treasurer.jpg";

const board = [
  { name: "President", image: President },
  { name: "External VP", image: EVP },
  { name: "Internal VP", image: IVP },
  { name: "Secretary", image: Secretary },
  { name: "Treasurer", image: Treasurer },
];

const BoardPreview = () => {
  return (
    <Box sx={{ bgcolor: "background.paper", px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "90px" } }}>
      <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
        <EyebrowLabel color="secondary.main">2026-2027</EyebrowLabel>
        <Typography variant="h2" sx={{ mt: "4px", mb: { xs: "32px", md: "48px" } }}>
          Meet the Board
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: { xs: "6px", sm: "12px", md: "16px" },
          }}
        >
          {board.map(({ name, image }) => (
            <Box key={name} sx={{ textAlign: "center" }}>
              <Box
                component="img"
                src={image}
                alt={name}
                sx={{
                  width: "100%",
                  aspectRatio: "1 / 1",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: { xs: "2px solid", md: "4px solid" },
                  borderColor: "primary.main",
                  display: "block",
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  mt: { xs: "6px", md: "16px" },
                  color: "primary.main",
                  fontSize: { xs: "0.55rem", sm: "0.85rem", md: "1.1rem" },
                  lineHeight: 1.2,
                }}
              >
                {name}
              </Typography>
            </Box>
          ))}
        </Box>

        <Typography
          component="a"
          href="/board"
          variant="h6"
          sx={{
            display: "block",
            textAlign: "center",
            width: "fit-content",
            mx: "auto",
            mt: { xs: "32px", md: "40px" },
            color: "primary.main",
            borderBottom: "3px solid",
            borderColor: "secondary.main",
            pb: "4px",
            textDecoration: "none",
            fontSize: { xs: "1rem", sm: "1.1rem" },
          }}
        >
          See Full Board →
        </Typography>
      </Box>
    </Box>
  );
};

export default BoardPreview;
